/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgAdd: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="currentColor"
                d="M12 4a1.5 1.5 0 011.5 1.5v5h5a1.5 1.5 0 010 3h-5v5a1.5 1.5 0 01-3 0v-5h-5a1.5 1.5 0 010-3l5-.001V5.5A1.5 1.5 0 0112 4z"
            />
        </g>
    </svg>
);
